// Parses "N - DD/MM/YYYY" lot number strings, comparing date first then lot number numerically.
// Needed because the mettler toledo resets lot numbers at midnight, so lots from different dates must
// be distinguished before comparing the numeric portion.
// Legacy lots without a date suffix (dateKey = "") sort before all dated lots.
export function compareWeighLotNumber(
  valueA: string | null | undefined,
  valueB: string | null | undefined,
) {
  const parse = (val: string) => {
    const [numPart, datePart] = val.split(" - ");
    const [dd, mm, yyyy] = (datePart ?? "").split("/");
    const dateKey = yyyy && mm && dd ? `${yyyy}/${mm}/${dd}` : datePart ?? "";
    return { dateKey, num: parseInt(numPart ?? "", 10) || 0 };
  };

  const a = parse(String(valueA ?? ""));
  const b = parse(String(valueB ?? ""));

  if (a.dateKey !== b.dateKey) {
    return a.dateKey < b.dateKey ? -1 : 1;
  }
  return a.num - b.num;
}

export function compareOnlyNumericCharacters(
  valueA: string | null | undefined,
  valueB: string | null | undefined,
) {
  const valA = String(valueA ?? "");
  const valB = String(valueB ?? "");

  // strip non numeric characters
  const valueAIntegers = valA.replace(/\D/g, "");
  const valueBIntegers = valB.replace(/\D/g, "");

  // sort naturally
  return valueAIntegers.localeCompare(valueBIntegers, "en", { numeric: true });
}
